<!-- 区域管理 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="editZone()"  v-if="permission.addZone">添加区域</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">区域名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Keyword" v-filter-special-char="searchData.Keyword" placeholder="区域名称或编码"></el-input>
                <div class="search-name">状态</div>
                <el-select v-model="searchData.State" class="search-item" size="small" placeholder="请选择">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%"
            >
                <el-table-column label="区域编号" width="120px">
                    <template slot-scope="scope">{{ scope.row.Code }}</template>
                </el-table-column>
                <el-table-column prop="Name" label="区域名称" width="200px"></el-table-column>
                <el-table-column prop="SSCount" label="仓位数量" width="140px"></el-table-column>
                <el-table-column label="状态" width="140px">
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="Remark" label="备注"></el-table-column>
                <el-table-column width="180px" prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column width="130px" prop="Updatetor" label="最后更新人"></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.editZone" title="编辑" size="mini" type="text" @click="editZone(scope.row)"
                                >编辑</el-button
                            >
                            <el-button
                                v-if="permission.delZone"
                                title="删除"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="delPosition(scope.row)"
                                >删除</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50, 100, 150]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!--    新增/编辑区域    -->
        <el-dialog :close-on-click-modal="false" :title="editDialogTitle" :visible.sync="editVisible" width="800px">
            <div v-loading="loading">
                <el-form :model="submitData" ref="formMsg" label-width="80px" style="width: 100%;padding: 10px 30px 0 0" :rules="rules">
                    <div class="form-main">
                        <div class="form-left">
                            <el-form-item label="区域编号" prop="Code">
                                <el-input v-model.trim="submitData.Code" placeholder="请输入数字或英文"> </el-input>
                            </el-form-item>
                        </div>
                        <div class="form-right">
                            <el-form-item label="区域名称" prop="Name">
                                <el-input style="width: 100%" v-model.trim="submitData.Name"> </el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-bottom">
                        <el-form-item label="备注">
                            <el-input style="width: 100%" v-model.trim="submitData.Remark"> </el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="submitData.State" style="width: 50%" placeholder="请选择">
                                <el-option v-for="item in editStateList" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" @click="submitForm">提交</el-button>
                    <el-button @click="cancel()">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        breadcrumb,
        elTableColumn,
    },
    name: '',
    data() {
        const checkPath = (rule, value, callback) => {
			this.submitData.Code = value.replace(/[\u4E00-\u9FA5]/g, "");
			callback();
		};
        return {
            stateList: [
                { Value: '', Text: '全部' },
                { Value: '0', Text: '正常使用' },
                { Value: '1', Text: '暂停使用' }
            ],
            warehouseName: '',
            dialogTitle: '区域信息',
            editVisible: false,
            editDialogTitle: '',
            loading:false,
            submitData: {
                WarehouseId: '',
                Id: '',
                Name: '',
                Code: '',
                State: 0,
                Remark: '',
            },
            searchData: {
                WarehouseId: '',
                Keyword: '',
                State: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            editStateList: [
                { Value: 0, Text: '正常使用' },
                { Value: 1, Text: '暂停使用' }
            ],
            rules: {
                Name: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Code: [{ validator: checkPath,required: true, message: '该项必填', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.searchData.WarehouseId = this.$route.query.id;
        this.warehouseName = this.$route.query.warehouse;
        this.permission = this.$util.getPermission('warehouse');
        this.getTableData();
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常使用';
            } else if (value == 1) {
                return '暂停使用';
            }
        }
    },
    methods: {
        cancel(edit) {
            this.editVisible = false;
        },
        editZone(row) {
            this.loading = false;
            this.editDialogTitle = this.warehouseName;
            
            if (row) {
                this.editDialogTitle = this.warehouseName + row.Name;
                this.submitData = {
                    WarehouseId: this.searchData.WarehouseId,
                    Id: row.Id,
                    Name: row.Name,
                    Code: row.Code,
                    State: row.State,
                    Remark: row.Remark,
                };
            }else{
                this.submitData = {
                    WarehouseId: this.searchData.WarehouseId,
                    Id: '',
                    Name: '',
                    Code: '',
                    State: 0,
                    Remark: '',
                };
            }
            this.editVisible = true;
        },
        // 提交
        submitForm() {
            let that = this;
            if(!that.submitData.Code){
                that.$util.errorMsg("请输入编码");
                return
            }
            if(!that.submitData.Name){
                that.$util.errorMsg("请输入名称");
                return
            }
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/EntpShelfSpaces/AddOrUpdateZone',
                    data: that.submitData
                })
                .then(res => {
                    if(res.errcode == 0){
                        that.editVisible = false;
                        that.$util.successMsg(res.errmsg);
                        that.searchData.page = 1;
                        that.getTableData();
                    }else
                        that.$util.errorMsg(res.errmsg);
                    
                }).catch(() => {
                    that.loading = false;
                });
        },
        // 删除仓位
        delPosition(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该区域吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpShelfSpaces/DelZone',
                            data: {
                                WarehouseId: that.searchData.WarehouseId,
                                Id: row.Id
                            }
                        })
                        .then(res => {
                            if(res.errcode == 0){
                                that.$util.successMsg('删除成功');
                                that.searchData.page = 1;
                                that.getTableData();
                            }else{
                                that.$util.errorMsg(res.errmsg);

                            }
                        });
                }
            });
        },
        resetSearch() {
            this.searchData = {
                WarehouseId: this.searchData.WarehouseId,
                Keyword: '',
                State: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetZoneList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = {};
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        batchAddSpaces() {
            this.$router.push(`/inventoryManage/batchAddSpaces?id=${this.searchData.WarehouseId}&name=${this.warehouseName}`);
        }
    }
};
</script>
<style lang="less">
.dialog-footer{
    display: flex;
    justify-content:flex-end;
    margin-bottom: 10px;
}

</style>